<style lang="scss" scoped src="./style.scss"></style>

<template>
  <div
    class="card"
    :class="[
      {
        'card--loading': loading,
        'card--no-padding': noPadding,
        'card--error': hasError || hasWarning,
      }
    ]"
  >
    <v-spinner
      class="card__loading"
      :show="loading"
    />
    <div
      v-if="hasError"
      class="card__error"
    >
      <div>{{ error }}</div>

      <v-button
        icon-left="redo"
        class="btn btn--error"
        @click.prevent="$emit('retry')"
      >
        Retry
      </v-button>
    </div>
    <div
      v-if="hasWarning"
      class="card__error"
    >
      <div>{{ warning }}</div>

      <v-button
        class="btn btn--secondary"
        :href="warningLink"
      >
        {{ warningLinkText }}
      </v-button>
    </div>
    <div
      v-if="hasOverlay"
      class="card__overlay"
    >
      <slot name="overlay" />
    </div>

    <div
      v-if="title"
      class="card__header"
    >
      <h4
        class="card__header-title"
      >
        {{ title }}
      </h4>
      <div
        v-if="hasHeaderOptionsSlot"
        class="card__header-options"
      >
        <slot name="options" />
      </div>
    </div>
    <div class="card__body">
      <slot />
    </div>
    <div
      v-if="hasFooterSlot"
      class="card__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    error: {
      type: [String, undefined],
      default: '',
    },
    warning: {
      type: [String, undefined],
      default: '',
    },
    warningLink: {
      type: [String, undefined],
      default: '#',
    },
    warningLinkText: {
      type: [String, undefined],
      default: 'Retry',
    },
    hasOverlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasError() {
      return this.error && this.error.length > 0;
    },
    hasWarning() {
      return this.warning && this.warning.length > 0;
    },
    hasHeaderOptionsSlot() {
      return this.$slots.options !== undefined;
    },
    hasFooterSlot() {
      return this.$slots.footer !== undefined;
    },
  },
};
</script>
